import { Inject, Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment, ENVIRONMENT_TOKEN } from '../../../core/environment.service';
import { PropertyUser, PropertyUserDto } from '../models';

@Injectable()
export class PropertyUserDataService extends EntityCollectionServiceBase<PropertyUserDto> {

    constructor(serviceElementaryFactory: EntityCollectionServiceElementsFactory,
                @Inject(ENVIRONMENT_TOKEN) private environment: Environment) {
        super('PropertyUser', serviceElementaryFactory);
    }

    entities$: Observable<PropertyUser[]> = this.entities$.pipe(
        map(entities => {
            if (!entities) {
                return [];
            }
            return entities.map((entity) => {
                return new PropertyUser(entity);
            });
        })
    );
}
